// utils/lockUiHelpers.js
//
// Shared presentation helpers for lock-related components. Anything that
// needs to be visually consistent across LockStatusPanel, LockMappingModal,
// and AdminDashboardLockTable lives here.

/**
 * Map a battery level (0–100) to a CSS color used by the battery badge.
 * Thresholds match the same brackets used by the `lock.low_battery` alert
 * trigger (<20 = critical) so the visual cue reinforces the alert logic.
 */
export const batteryColor = (level) => {
  if (level == null) return '#6c757d';   // unknown — neutral gray
  if (level < 20) return '#dc3545';      // critical — red (matches Bootstrap danger)
  if (level < 50) return '#fd7e14';      // low — orange (matches Bootstrap warning)
  return '#28a745';                       // healthy — green (matches Bootstrap success)
};
